import { api } from './api';
import { TimeEntry, ActivityType } from '../types';

export interface CreateTimeEntryRequest {
  caseId: string;
  date: string;
  duration: number;
  activityType: ActivityType;
  description: string;
  billable?: boolean;
}

export interface UpdateTimeEntryRequest {
  date?: string;
  duration?: number;
  activityType?: ActivityType;
  description?: string;
  billable?: boolean;
}

export interface TimeListResponse {
  timeEntries: TimeEntry[];
  count: number;
  totalMinutes: number;
  billableMinutes: number;
}

export const timeApi = {
  list: async (caseId?: string, startDate?: string, endDate?: string): Promise<TimeListResponse> => {
    const params = new URLSearchParams();
    if (caseId) params.append('caseId', caseId);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const queryString = params.toString();
    return api.get<TimeListResponse>(`/time${queryString ? `?${queryString}` : ''}`);
  },

  get: async (id: string): Promise<TimeEntry> => {
    return api.get<TimeEntry>(`/time/${id}`);
  },

  create: async (data: CreateTimeEntryRequest): Promise<TimeEntry> => {
    return api.post<TimeEntry>('/time', data);
  },

  update: async (id: string, data: UpdateTimeEntryRequest): Promise<TimeEntry> => {
    return api.put<TimeEntry>(`/time/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/time/${id}`);
  },
};
